<template>
    <a v-if="href" style="width: 160px;line-height:3.4;border-radius: 26px;" class="button dib fs14 center" :class="{disabledbutton: disabled, btn1: true}" @click="onClick" :disabled="disabled" :download="download" :href="href" target="_blank">
        {{ text }}
    </a>
    <a v-else style="width: 160px;line-height:3.4;border-radius: 26px;" class="button dib  fs14 center" :class="{disabledbutton: disabled, btn1: true}" @click="onClick" :disabled="disabled" :download="download">
        {{ text }}
    </a>
</template>
<script>
export default {
    name: 'ubutton',
    props: {
        text: {type: String, default: ''},
        disabled: {type: Boolean, defualt: false},
        download: {type: Boolean, defualt: false},
        href: {type: String, default: ''},
    },
    methods: {
        onClick() {
            if (!this.disabled) {
                this.$emit('click');
            }
        },
    }
}
</script>
